import actions from './action'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    session: '',
    downloadLink_copy: '',
    downloadLink_qrcode: '',
    lang: ''
  },
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Common/index.js